.controlsDesktop:not(:focus, :active) {
  @container carousel-header (width <= 767px) {
    clip-path: inset(50%);
    height: 1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
}

.controlsMobile:not(:focus, :active) {
  @container carousel-header (width >= 768px) {
    clip-path: inset(50%);
    height: 1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
}

.scrollArea {
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
  overflow-x: scroll;
  position: relative;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
  margin-left: -24px;
  margin-right: -24px;
  margin-top: -12px;
  margin-bottom: -12px;
  padding-left: 24px;
  scroll-padding-left: 24px;
  scroll-padding-right: 16px;

  @media (--reefer-media-tablet-min) {
    overflow-x: auto;
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    scroll-padding-left: 0;
    scroll-padding-right: 0;
  }
}

.scrollArea_noScroll {
  overflow-x: hidden;
}

.scrollArea::-webkit-scrollbar {
  width: 0;
}

.scrollArea:focus-visible {
  outline: none;
  border-bottom: 1px solid var(--colors-primary-main);
  border-top: 1px solid var(--colors-primary-main);
}

.grid {
  display: grid;
  grid-auto-columns: calc(
    var(--carousel-card-width-mobile) + var(--carousel-card-gap-mobile)
  );
  grid-auto-flow: column;
  grid-template-rows: var(--carousel-card-grid-template-rows);
  padding-bottom: 12px;
  padding-top: 12px;
  row-gap: var(--carousel-card-gap-mobile);

  &::after {
    content: '';
    width: 8px;
  }

  @media (--reefer-media-tablet-min) {
    column-gap: var(--carousel-card-gap);
    grid-auto-columns: var(--carousel-card-width);
    grid-template-rows: auto;
    row-gap: var(--carousel-card-gap);

    &::after {
      display: none;
    }
  }
}

.skeletonBone {
  height: var(--carousel-skeleton-height-mobile);

  @media (--reefer-media-tablet-min) {
    height: var(--carousel-skeleton-height);
  }
}

.arrowFilled {
  background-color: var(--colors-grays-white);
}

.link {
  white-space: nowrap;
}

.viewAllLink {
  width: max-content;
}
